import type { SerpBannerConfig } from '../types';

const desktopTourHotConfig = {
    fixed: [
        { id: 'adfox', cardIndex: 4 },
    ],
    queue: [
        { id: 'assistantSales', priority: 1, repeatMode: 'repeat' },
        { id: 'anniversary15',  priority: 2, repeatMode: 'repeat' },
        { id: 'emirates',       priority: 3, repeatMode: 'repeat' },
        { id: 'buyNow',         priority: 4, repeatMode: 'repeat' },
        { id: 'catchPrice',     priority: 5, repeatMode: 'repeat' },
        { id: 'dreamTour',    priority: 6, repeatMode: 'repeat' },
        { id: 'tourIncludes', priority: 7, repeatMode: 'repeat' },
        { id: 'hacks8',       priority: 8, repeatMode: 'repeat' },
        { id: 'appPromo',     priority: 9, repeatMode: 'repeat' },
    ],
} as const satisfies SerpBannerConfig;

export default desktopTourHotConfig;
